<!-- <template>
    <div class="body">
        <h1>广告点位与停车场综合管理平台</h1>
        <div class="login-form">
            <div class="head-info">
            </div>
            <div class="clear"> </div>
            <div class="avtar">
                <img src="../assets/image/avtar.png">
				
            </div>
            <el-form @keyup.enter.native="submitForm">
                <input type="text" class="text" v-model="formLogin.user_login_id" placeholder="用户名" >
                <div class="key"><input type="password" class="password" v-model="formLogin.user_pwd" placeholder="密码"></div>
				<div class="verify">
					<input type="text"  class="text1" v-model="formLogin.verify_code" placeholder="请输入验证码" >
					<img :src='verifycode' @click='refreshCode' style="cursor: pointer;">
				</div>
            </el-form>
            <div class="signin"><input type="submit" value="登录" @click="submitForm"></div>
        </div>
		<div style="margin-top: 25px;">
			<a style="color: white;font-size: 0.8rem;text-decoration: none;" target='_blank' href="https://beian.miit.gov.cn/">粤ICP备12033416号-4</a>
		</div>
    </div>
</template> -->


<template>
    <div class="body">
		<div class="content container">
			<el-row style="width: 100%;">
				<el-col :xs="24" :md="14" class="a">
					<img src="../assets/image/a1.png">
				</el-col>
				<el-col :xs="24" :md="10">
					<div class="d">
						<div class="d_child">广告点位与停车场综合管理平台</div>
						<el-form @keyup.enter.native="submitForm" >
							<div class="form">
								<el-input placeholder="用户名" v-model="formLogin.user_login_id"  size='medium' style="margin-top: 15px;">
									<template slot="prepend">
										<img src="../assets/image/yonghu.png" class="img1">
									</template>
								  </el-input>
	
								  <el-input type="password" placeholder="密码" v-model="formLogin.user_pwd"  size='medium' style="margin-top: 30px;">
									<template slot="prepend">
										<img src="../assets/image/key.png" class="img1">
									</template>
								  </el-input>

								  <div class="verify">
									<el-input placeholder="请输入验证码" v-model="formLogin.verify_code"  size='medium' >
										<template slot="prepend">
											<img src="../assets/image/yzm.png" class="img1">
										</template>
									  </el-input>
									  <img :src='verifycode' @click='refreshCode' class="verify_img" style="cursor: pointer;margin-left: 15px;">
								  </div>
							</div>
						</el-form> 
						<el-button type="primary" size='medium' style="width: 80%;height:40px;background-color: #0F7AFE;margin-top: 50px;" @click='submitForm'>登录</el-button>
					</div>
					
				</el-col>
			</el-row>
		</div>
       
    </div>
</template>




<script>
import util from '../util/util'
import attr from '../../vue.config'
import guid from 'guid'


export default {
    data () {
        return {
            formLogin: {
                user_login_id: '',
                user_pwd: '',
				verify_code:''
            },
            isphone: false,
            screenWidth: 0,
            remenber: false,
            rules: {
                user_login_id: [{ required: true, message: '请输入用户名', trigger: 'blur' }]
            },
			verifycode:'',

			uuid:''
        }
  },
  created () {
	  this.uuid=guid.raw()
  },
  mounted () {
    this.remenber = false
    var item= window.localStorage.getItem('ca_login_info')
    if (item !== null&&item!==undefined) {
      this.remenber = true
      this.formLogin=JSON.parse(item)
    }
	this.getVerifyCode()
  },
  methods:{
    submitForm () {
        if(!this.formLogin.user_login_id){
            this.$message.error('登录账号禁止为空')
            return
        }
		this.formLogin.uid=this.uuid
        util.Post('Login/CheckLogin', this.formLogin).then(res => {
            if (res.rpStatus === 10000) {
              	window.sessionStorage.setItem('ca_login_token', res.rpMsg)// token
              	window.sessionStorage.setItem('MeunItem', JSON.stringify(res.list[0].listMenu))
			  	window.sessionStorage.setItem('user_auth', JSON.stringify(res.list[0].listAuth))
              	this.$router.push('/home')
            } else {
              this.$message.error(res.rpMsg)
            }
        })
    },
	getVerifyCode(){
		this.verifycode = attr.devServer.proxy['/api'].target+"/login/Captcha?uid="+this.uuid+"&time=" + new Date()
	},
	refreshCode(){
		this.getVerifyCode()
	}
  }
}
</script>

<style scoped>
	.body{
		font-family: 'Open Sans', sans-serif;
		-webkit-background-size:cover;
		-moz-background-size:cover;
		-o-background-size:cover;
		width: 100%;
		height: 100%;
		margin:0;
		background: url("../assets/image/login.png") no-repeat 0px 0px;
		overflow: hidden;
		background-size: cover;
	}

	.content{
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		height: 100%;
	}
	.container{
		width: 60%;
		margin-left: 20%;
	}

	.a{
		display: block;
	}

	.a img{
		height: 500px;
		width: 100%;
		border-radius: 10px 0 0 10px
	}

	.img1{
		width: 20px;
		height: 20px;
	}


	.d{
		border: 1px solid white;
		background-color: white;
		border-radius:0 10px 10px 0;
		height: 500px;
		width: 100%;
	}
	.d_child{
		color: #3676D9;
		font-size: 22px;
		margin-top: 35px;
		margin-bottom: 30px;
		font-weight: 600;
		font-family:'Open Sans', sans-serif;
	}

	.form{
		margin-top: 30px;
		width: 80%; 
		margin-left: 20px;
		display: flex;
		flex-direction: column;
		align-items: center;
	}


	.verify{
		margin-top: 30px;
		display: flex;
		flex-direction: row;
		align-items: center;
		width: 100%;
	}

	.verify_img{
		height: 30px;
		width: 150px;
		
	}
	
@media (max-width:1280px){
	.container{
		width: 80%;
		margin-left: 10%;
	}
}
@media (max-width:1024px){
	.container{
		width: 80%;
		margin-left: 10%;
	}
}
@media (max-width:768px){
	.a{
		display: none;
	}
}
@media (max-width:480px){
	.verify_img{
		height: 30px;
		width: 100px;
	}
}





	

	/deep/ .el-input-group__prepend{
    	background-color: white;
		border: none;
	}
</style>